import { STATUS_TYPE } from '../../../enum';

export interface IInitialState {
  id?: string;
  labelEn: string;
  labelAr: string;
  duration: string;
  price: string;
  code: string;
  type: string;
  activeState: boolean;
  packageType?: string;
  creditCount?: string;
  creditExpirationDays?: string;
  companyId?: string | null;
  companyIds?: string[]; // Array for multiple company selection
  companySelection?: string; // 'all' or 'specific'
  brokerId?: string | null;
  brokerIds?: string[]; // Array for multiple broker selection
  brokerSelection?: string; // 'all' or 'specific'
}

export interface GetAdvertisePackage {
  id: string;
}

export interface FindAdvertisePackage {
  limit?: number;
  skip?: number;
  type?: string;
  search?: string;
}

export interface CreatePatchAdvertisePackage {
  id?: string;
  labelEn: string;
  labelAr: string;
  duration: string;
  price: string;
  code: string;
  type: string;
  activeState: boolean;
  packageType?: string;
  creditCount?: number;
  creditExpirationDays?: number;
  companyId?: string | null;
  companyIds?: string[] | null;
  brokerId?: string | null;
  brokerIds?: string[] | null;
}

export interface AdvertisePackage {
  id: string;
  labelEn: string;
  labelAr: string;
  duration: string;
  price: string;
  code: string;
  type: string;
  activeState: boolean;
  packageType?: string;
  creditCount?: number;
  creditExpirationDays?: number;
  companyId?: string | null;
  companyIds?: string[] | null;
  brokerId?: string | null;
  brokerIds?: string[] | null;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: AdvertisePackage[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
